import { combineReducers } from "redux"

// Importing reducers
import { variaveisReducer } from "./variaveisReducer";
import { edgesReducer } from "./edgesReducer"
import { nodesReducer } from "./nodesReducer"
import { rectsReducer } from "./rectsReducer"
import { avatarsReducer } from "./avatarsReducer"

const rootReducer = combineReducers({
    variaveis: variaveisReducer,
    edges: edgesReducer,
    nodes: nodesReducer,
    rects: rectsReducer,
    avatars: avatarsReducer
})

export default rootReducer
